export const GIA_MODULE_KNOWLEDGE = {
  menu: {
    key: 'menu',
    label: 'Inicio',
    sectionLabel: 'Inicio',
    summary: 'Inicio te muestra cómo está la empresa y qué módulo conviene abrir según la tarea del día.',
    purpose: 'Darte contexto rápido para arrancar con orden.',
    canDo: [
      'Leer el estado comercial y los módulos activos.',
      'Entrar a logística, servicio, stock y movimientos, monitor en tiempo real, reportes y liquidación o guía y soporte sin perder el hilo.',
      'Entender si el entorno está activo, por vencer o pausado.',
    ],
    commonIssues: [
      'No saber qué módulo conviene abrir primero.',
      'Confundir un problema comercial con uno operativo.',
      'Perder tiempo entrando a módulos que no resuelven la tarea del día.',
    ],
    nextStepHint: 'Si ya sabés qué tarea tenés que resolver, desde Inicio conviene saltar directo al módulo correcto.',
  },
  logistics: {
    key: 'logistics',
    label: 'Logística',
    sectionLabel: 'Logística',
    summary: 'En Logística armás tus unidades de trabajo, cargás chofer y transporte, y después preparás rutas con destinos.',
    purpose: 'Ordenar la operación diaria desde la unidad hasta la ruta.',
    canDo: [
      'Crear unidades, rutas y hojas de trabajo.',
      'Tomar pedidos pendientes y convertirlos en carga operativa.',
      'Seguir retiros, entregas, garantía y regreso dentro del mismo flujo.',
    ],
    commonIssues: [
      'No ver un pedido porque todavía no fue tomado como carga operativa.',
      'No entender por qué un destino sigue pendiente.',
      'Querer resolver entregas o retiros desde un módulo que no corresponde.',
    ],
    nextStepHint: 'Si el problema tiene que ver con viaje, destino, retiro o entrega, casi siempre se resuelve acá.',
  },
  stock: {
    key: 'stock',
    label: 'Stock y movimientos',
    sectionLabel: 'Stock y movimientos',
    summary: 'En Stock registrás compras, controlás cantidades y preparás salidas antes de que la operación pase a ruta.',
    purpose: 'Tener claro qué entró, qué salió, qué queda y qué necesita revisión.',
    canDo: [
      'Cargar compras con producto, cantidad y costo.',
      'Preparar salidas completas o parciales para que Logística las tome.',
      'Revisar estados como guardado, pendiente, tránsito, garantía o sin stock.',
    ],
    commonIssues: [
      'No entender por qué una cantidad no bajó todavía.',
      'Confundir guardado, pendiente, tránsito y garantía.',
      'Buscar una salida en Logística que todavía no fue preparada desde Stock.',
    ],
    nextStepHint: 'Si el tema es producto, compra, salida, diferencia o garantía, el primer lugar es Stock.',
  },
    monitor: {
    key: 'monitor',
    label: 'Monitor en tiempo real',
    sectionLabel: 'Monitor en tiempo real',
    summary: 'En Monitor en tiempo real ves qué rutas siguen activas y qué unidad está en movimiento.',
    purpose: 'Tener una lectura rápida de lo que está pasando sin bajar a cada ruta.',
    canDo: [
      'Ver varias rutas activas al mismo tiempo.',
      'Detectar qué unidad sigue trabajando y cuál ya cerró.',
      'Leer el estado general de la operación sin entrar al detalle completo.',
    ],
    commonIssues: [
      'Querer cambiar una ruta desde Monitor en vez de leerla.',
      'No distinguir si una unidad está activa o ya cerró ciclo.',
      'Esperar detalle profundo en una vista pensada para mirada general.',
    ],
    nextStepHint: 'Si querés ver el pulso general, Monitor en tiempo real es el lugar correcto. Si necesitás operar, el próximo paso suele ser Logística.',
  },
  reports: {
    key: 'reports',
    label: 'Reportes y liquidación',
    sectionLabel: 'Reportes y liquidación',
    summary: 'Reportes y liquidación transforma la operación en lectura clara, balances y cierre económico.',
    purpose: 'Cerrar el ciclo con mirada histórica y económica.',
    canDo: [
      'Revisar balances, movimientos y diferencias.',
      'Leer costos, ventas y márgenes visibles.',
      'Consolidar qué pasó sin navegar módulo por módulo.',
    ],
    commonIssues: [
      'Querer cargar datos desde una vista pensada para análisis.',
      'No entender de qué módulo viene un número.',
      'Buscar detalle operativo donde la vista resume y consolida.',
    ],
    nextStepHint: 'Si ya no querés operar sino entender, comparar o liquidar, este módulo es el paso lógico.',
  },
  fleetExpenses: {
    key: 'fleetExpenses',
    label: 'Gastos de Flota',
    sectionLabel: 'Gastos de Flota',
    summary: 'Gastos de Flota reúne combustible, service y costos asociados al parque móvil.',
    purpose: 'Agregar lectura económica a cada unidad y completar el rendimiento operativo.',
    canDo: [
      'Registrar gastos por vehículo.',
      'Comparar costos frecuentes.',
      'Sumar contexto económico a la operación diaria.',
    ],
    commonIssues: [
      'No distinguir un gasto operativo de un gasto de flota.',
      'Esperar impacto inmediato en rutas cuando acá se trabaja el costo.',
      'No saber si conviene registrar un gasto por unidad o por operación.',
    ],
    nextStepHint: 'Si la pregunta es cuánto cuesta mover la operación, este módulo toma protagonismo.',
  },
  systemGuide: {
    key: 'systemGuide',
    label: 'Guía y soporte',
    sectionLabel: 'Guía y soporte',
    summary: 'Guía y soporte te explica qué hace cada módulo, qué tenés activo hoy y por dónde conviene empezar.',
    purpose: 'Bajar la complejidad a una lectura clara y útil.',
    canDo: [
      'Explicar qué resuelve cada módulo.',
      'Ordenar primeros pasos según el plan activo.',
      'Conectar tutoriales y decisiones comerciales.',
    ],
    commonIssues: [
      'No saber por dónde empezar.',
      'No entender qué habilita el plan activo.',
      'Necesitar una explicación humana antes de operar.',
    ],
    nextStepHint: 'Si necesitás una explicación antes de operar, Guía y soporte te ordena rápido.',
  },
  architect: {
    key: 'architect',
    label: 'Arquitectura',
    sectionLabel: 'Arquitectura',
    summary: 'Arquitectura mira el sistema completo: empresas, planes, solicitudes y salud general.',
    purpose: 'Supervisar sin invadir el operativo interno de los clientes.',
    canDo: [
      'Leer estado comercial y módulos por empresa.',
      'Crear Laboratorio y ordenar el entorno propio.',
      'Detectar solicitudes y evolución general del producto.',
    ],
    commonIssues: [
      'Querer operar una empresa cliente desde un panel que es ejecutivo.',
      'Confundir salud del sistema con operación diaria.',
      'No distinguir entre entorno interno, comercial y de laboratorio.',
    ],
    nextStepHint: 'Arquitectura no está para operar una empresa cliente, sino para entender el sistema y decidir próximos pasos.',
  },
};

export const GIA_SUBSECTION_KNOWLEDGE = {
  menu: {
    'Panel principal': {
      summary: 'Panel principal concentra el pulso del día y te ayuda a decidir rápido qué módulo conviene abrir.',
      purpose: 'Ordenar el arranque operativo sin entrar a ciegas.',
      canDo: [
        'Leer estado comercial, módulos activos y alertas visibles.',
        'Saltar al módulo correcto sin romper el hilo de trabajo.',
        'Entender si el problema es comercial, operativo o de acompañamiento.',
      ],
      commonIssues: [
        'Entrar a Inicio esperando operar una tarea que vive en otro módulo.',
        'No distinguir si conviene ir a Stock, Logística o Monitor.',
      ],
      nextStepHint: 'Desde Panel principal conviene decidir el módulo correcto antes de empezar a operar.',
    },
    'Planes y continuidad': {
      summary: 'Planes y continuidad reúne trial, estado comercial y solicitud de upgrade sin mezclarlo con la operación.',
      purpose: 'Explicar qué está activo hoy y qué falta habilitar.',
      canDo: [
        'Ver el estado del trial o la suscripción actual.',
        'Entender qué módulos corresponden al plan activo.',
        'Pedir continuidad o un cambio de plan.',
      ],
      commonIssues: [
        'Confundir un bloqueo comercial con una falla técnica.',
        'Esperar módulos habilitados que no corresponden al plan actual.',
      ],
      nextStepHint: 'Si algo está pausado por plan o vencimiento, primero se aclara acá.',
    },
  },
  logistics: {
    'Choferes y unidades': {
      summary: 'Choferes y unidades ordena la base operativa antes de abrir una unidad puntual.',
      purpose: 'Dar una vista central del parque móvil y la base humana sin perder claridad.',
      canDo: [
        'Abrir una unidad puntual para trabajarla.',
        'Leer cuántos choferes y unidades están cargados.',
        'Entrar al módulo de choferes o crear nuevos registros.',
      ],
      commonIssues: [
        'Querer abrir una hoja de ruta sin entrar antes a la unidad correcta.',
        'Confundir el tablero general con una vista individual.',
      ],
      nextStepHint: 'Si todavía no elegiste una unidad, este es el tablero base para hacerlo.',
    },
    'Choferes': {
      summary: 'Choferes muestra la base humana operativa y sus accesos, estados y vínculos con unidades.',
      purpose: 'Entender quién está disponible, asignado o pendiente sin bajar a cada unidad.',
      canDo: [
        'Revisar estado, acceso y unidad actual de cada chofer.',
        'Entrar a la ficha destacada del chofer en foco.',
        'Abrir una nueva ruta o copiar su acceso operativo.',
      ],
      commonIssues: [
        'Esperar datos de una unidad cuando la vista está centrada en choferes.',
        'No distinguir entre el acceso del chofer y la unidad donde trabaja.',
      ],
      nextStepHint: 'Si la duda es sobre personas, accesos o asignaciones, la lectura correcta arranca acá.',
    },
    'Base operativa': {
      summary: 'Base operativa reúne calendario, rutas del día y el tablero de la unidad seleccionada.',
      purpose: 'Preparar una ruta nueva o revisar lo que ya está corriendo en esa unidad.',
      canDo: [
        'Leer el calendario y las rutas visibles de la unidad.',
        'Abrir una ruta puntual.',
        'Ir a crear una nueva hoja de ruta.',
      ],
      commonIssues: [
        'No encontrar una ruta porque se está mirando otra unidad.',
        'Confundir historial filtrado por fecha con base operativa viva.',
      ],
      nextStepHint: 'Si ya elegiste una unidad, desde Base operativa decidís si abrís una ruta o creás una nueva.',
    },
    'Base operativa desplegada': {
      summary: 'Base operativa desplegada muestra varias unidades abiertas al mismo tiempo para una lectura comparativa rápida.',
      purpose: 'Leer más contexto sin entrar todavía al detalle fino.',
      canDo: [
        'Comparar varias unidades abiertas.',
        'Detectar cuál conviene profundizar.',
        'Leer acciones disponibles de cada tarjeta.',
      ],
      commonIssues: [
        'Querer editar detalle profundo desde una expansión pensada para lectura rápida.',
      ],
      nextStepHint: 'Usala para comparar y después cerrá el foco sobre una unidad concreta.',
    },
    'Unidad desplegada': {
      summary: 'Unidad desplegada abre una tarjeta expandida para leer más contexto sin salir del tablero.',
      purpose: 'Permitir una lectura intermedia antes de entrar al detalle completo.',
      canDo: [
        'Leer más datos de la unidad en foco.',
        'Ver acciones disponibles sin salir del tablero.',
      ],
      commonIssues: [
        'Pensar que la expansión ya es el detalle completo de la unidad.',
      ],
      nextStepHint: 'Si necesitás trabajar en serio esa unidad, el paso siguiente es abrir su detalle.',
    },
    'Detalle de unidad': {
      summary: 'Detalle de unidad pone el foco en una sola unidad con sus acciones y contexto operativo directo.',
      purpose: 'Trabajar sobre una unidad concreta sin ruido del resto.',
      canDo: [
        'Leer su estado, historial breve y acciones disponibles.',
        'Abrir hoja de ruta o profundizar en su operación.',
      ],
      commonIssues: [
        'Esperar una visión de toda la base cuando la lectura ya está concentrada en una sola unidad.',
      ],
      nextStepHint: 'Cuando la unidad correcta ya está elegida, desde acá empieza el trabajo fino.',
    },
    'Unidad individual': {
      summary: 'Unidad individual abre el circuito operativo de una sola unidad: base, rutas y hoja en foco.',
      purpose: 'Trabajar el flujo vivo de una unidad concreta.',
      canDo: [
        'Revisar rutas de esa unidad.',
        'Crear una hoja nueva.',
        'Abrir una ruta en detalle.',
      ],
      commonIssues: [
        'No entender por qué no aparecen rutas de otras unidades.',
      ],
      nextStepHint: 'Esta vista ya no es general: todo lo que ves corresponde a una sola unidad.',
    },
    'Nueva hoja de ruta': {
      summary: 'Nueva hoja de ruta prepara el trabajo operativo que después viaja al detalle y al monitor.',
      purpose: 'Armar una hoja clara antes de ponerla en circulación.',
      canDo: [
        'Cargar destinos y estructura de la ruta.',
        'Preparar el circuito operativo de esa unidad.',
      ],
      commonIssues: [
        'Querer cerrar o monitorear una ruta desde una pantalla pensada para crearla.',
      ],
      nextStepHint: 'Primero se arma la hoja; después se pasa al detalle para operarla.',
    },
    'Hoja de ruta': {
      summary: 'Hoja de ruta es la vista operativa detallada donde se sigue una ruta puntual y sus destinos.',
      purpose: 'Controlar el trabajo real de una ruta concreta.',
      canDo: [
        'Leer destinos, estados y evolución de la ruta.',
        'Entender qué quedó pendiente o completado.',
      ],
      commonIssues: [
        'Buscar el panorama general cuando ya estás en una ruta puntual.',
      ],
      nextStepHint: 'Si ya llegaste a Hoja de ruta, el foco es una sola operación puntual.',
    },
    'Historial por fecha': {
      summary: 'Historial por fecha filtra la lectura de una unidad para revisar recorridos de un día puntual.',
      purpose: 'Volver sobre operaciones ya ocurridas sin mezclarlo con la base viva.',
      canDo: [
        'Revisar rutas asociadas a una fecha concreta.',
        'Comparar un día puntual con el resto del ciclo.',
      ],
      commonIssues: [
        'Esperar ver lo vivo cuando la vista está filtrada históricamente.',
      ],
      nextStepHint: 'Si estás filtrando por fecha, la lectura ya es histórica y no del pulso actual.',
    },
  },
  monitor: {
    'Monitor en tiempo real': {
      summary: 'Monitor en tiempo real muestra el pulso vivo de las rutas activas sin bajar al detalle pesado.',
      purpose: 'Leer rápidamente qué sigue moviéndose y qué merece atención.',
      canDo: [
        'Ver rutas activas y unidades vivas.',
        'Detectar qué operación requiere entrar a Logística.',
      ],
      commonIssues: [
        'Querer editar una ruta desde una vista pensada para leerla.',
      ],
      nextStepHint: 'Monitor en tiempo real sirve para leer el pulso; si necesitás operar, el próximo salto suele ser Logística.',
    },
    'Historial operativo': {
      summary: 'Historial operativo mira recorridos ya ejecutados, no el pulso en tiempo real.',
      purpose: 'Volver sobre lo que pasó y entender antecedentes.',
      canDo: [
        'Revisar rutas cerradas o anteriores.',
        'Abrir un caso histórico en foco.',
      ],
      commonIssues: [
        'Esperar movimiento vivo cuando la vista ya es histórica.',
      ],
      nextStepHint: 'Si necesitás entender qué pasó antes, esta es la subvista correcta.',
    },
    'Balance general': {
      summary: 'Balance general condensa lectura histórica, operativa y económica en una sola vista.',
      purpose: 'Dar una mirada más ejecutiva sobre la actividad ya registrada.',
      canDo: [
        'Leer tendencias y balances del circuito.',
        'Detectar desvíos o acumulaciones.',
      ],
      commonIssues: [
        'Buscar detalle transaccional dentro de una vista de síntesis.',
      ],
      nextStepHint: 'Usá Balance general para entender, no para cargar ni corregir trabajo vivo.',
    },
    'Liquidación y reglas': {
      summary: 'Liquidación y reglas reúne parámetros, criterios y ajustes que ordenan el cierre económico.',
      purpose: 'Definir cómo se liquida y cómo se presenta la información consolidada.',
      canDo: [
        'Revisar reglas del módulo y parámetros de liquidación.',
        'Ajustar cómo se interpreta la información consolidada.',
      ],
      commonIssues: [
        'Confundir reglas de liquidación con operación diaria.',
      ],
      nextStepHint: 'Si el problema está en una regla, un criterio o una liquidación, esta es la subvista correcta.',
      },
    },
    fleetExpenses: {
      'Resumen de flota': {
        summary: 'Resumen de flota te da una lectura rápida de cuánto se está moviendo y cuánto cuesta sostener la operación móvil.',
        purpose: 'Entrar con una mirada general antes de cargar o revisar gastos puntuales.',
        canDo: [
          'Leer total filtrado, mes actual, movimientos y categoría líder.',
          'Detectar rápido si el costo se fue a una categoría puntual.',
        ],
        commonIssues: [
          'Querer decidir por una sola tarjeta sin mirar el historial.',
        ],
        nextStepHint: 'Si primero querés entender el panorama, arrancá por este resumen.',
      },
      'Registrar gasto': {
        summary: 'Registrar gasto carga fecha, categoría, unidad, monto y referencia para dejar trazabilidad del movimiento.',
        purpose: 'Ordenar cada gasto antes de que quede mezclado en el historial.',
        canDo: [
          'Cargar un gasto nuevo de una unidad puntual.',
          'Asociar categoría, transporte y chofer cuando hace falta.',
        ],
        commonIssues: [
          'Registrar el monto sin elegir bien la unidad o la categoría.',
        ],
        nextStepHint: 'Si tenés un gasto nuevo para registrar, esta es la parte correcta.',
      },
      'Categorías de gasto': {
        summary: 'Categorías de gasto ordena cómo clasificás combustible, service y otros costos de flota.',
        purpose: 'Mantener una lectura prolija para que después el historial y el resumen sean claros.',
        canDo: [
          'Revisar categorías base y sumar categorías nuevas.',
          'Ajustar cómo se clasifica cada gasto.',
        ],
        commonIssues: [
          'Duplicar categorías para el mismo tipo de gasto.',
        ],
        nextStepHint: 'Si el problema es cómo clasificar un gasto, mirá primero las categorías.',
      },
      'Historial de gastos': {
        summary: 'Historial de gastos muestra los movimientos ya cargados para revisar fechas, categorías, unidades y montos.',
        purpose: 'Seguir qué pasó con la flota sin mirar solo la foto actual.',
        canDo: [
          'Filtrar movimientos y revisar gastos visibles.',
          'Detectar diferencias o repeticiones en una unidad.',
        ],
        commonIssues: [
          'Buscar un patrón sin usar filtros por mes, categoría o unidad.',
        ],
        nextStepHint: 'Si querés revisar lo que ya se cargó, el foco está en Historial de gastos.',
      },
      'Distribución por categoría': {
        summary: 'Distribución por categoría te deja comparar visualmente qué tipo de gasto está pesando más en la flota.',
        purpose: 'Convertir el historial en una lectura rápida y comparativa.',
        canDo: [
          'Ver el peso económico de cada categoría.',
          'Detectar desbalances sin leer registro por registro.',
        ],
        commonIssues: [
          'Querer sacar conclusiones con muy pocos movimientos cargados.',
        ],
        nextStepHint: 'Si ya no buscás un caso puntual sino una lectura comparativa, pasá al gráfico.',
      },
    },
    stock: {
      'Planificación': {
        summary: 'Planificación ordena lo que hay que revisar hoy antes de mover producto o abrir controles.',
        purpose: 'Arrancar el día con una agenda clara dentro del depósito.',
        canDo: [
          'Ver tareas programadas y productos que necesitan atención.',
          'Definir qué control conviene empezar primero.',
        ],
        nextStepHint: 'Si todavía estás ordenando el día, arrancá por Planificación antes de abrir compras o salidas.',
      },
      'Productos': {
        summary: 'Productos reúne la base del depósito con cantidades, estado y acceso al historial de cada registro.',
        purpose: 'Tener clara la mercadería disponible antes de comprar, mover o preparar salidas.',
        canDo: [
          'Revisar cantidades y estado de cada producto.',
          'Abrir historial, control o compras relacionadas.',
        ],
        nextStepHint: 'Si la duda está en un producto puntual, esta es la sección correcta para empezar.',
      },
      'Compras': {
        summary: 'Compras registra lo que entra al depósito con proveedor, producto, cantidad, costo y fecha.',
        purpose: 'Dejar prolijo el ingreso de mercadería antes de que impacte en stock.',
        canDo: [
          'Cargar una compra nueva con proveedor y mercadería o ajustar una existente.',
          'Revisar qué ingreso quedó pendiente o incompleto.',
        ],
        nextStepHint: 'Si llegó mercadería o necesitás corregir un ingreso, el paso correcto es Compras.',
      },
      'Salidas': {
        summary: 'Salidas prepara pedidos y egresos para que después la operación los tome sin desorden.',
        purpose: 'Ordenar qué sale, cuánto sale y qué queda pendiente.',
        canDo: [
          'Armar pedidos de salida completos o parciales.',
          'Dejar lista la mercadería para que pase a operación.',
        ],
        nextStepHint: 'Si el trabajo es preparar lo que sale del depósito, la base está en Salidas.',
      },
      'Movimientos': {
        summary: 'Movimientos muestra el historial real de entradas, salidas, ajustes y diferencias del depósito.',
        purpose: 'Seguir qué pasó con cada producto sin mirar solo la foto actual.',
        canDo: [
          'Leer entradas, salidas y ajustes en orden.',
          'Detectar diferencias o movimientos fuera de lugar.',
        ],
        nextStepHint: 'Si necesitás entender qué pasó antes, Movimientos te da la secuencia completa.',
      },
      'Controladores': {
        summary: 'Controladores organiza quién revisa stock, ejecuta controles y deja registro de cada tarea.',
        purpose: 'Dar responsabilidad clara a los controles del depósito.',
        canDo: [
          'Ver responsables de control y su actividad.',
          'Ubicar quién está siguiendo cada revisión.',
        ],
        nextStepHint: 'Si el tema es quién controla o quién quedó a cargo, mirá Controladores.',
      },
      'Hojas de control': {
        summary: 'Hojas de control reúne los controles abiertos o cerrados para seguirlos sin perder contexto.',
        purpose: 'Mantener ordenadas las revisiones del depósito y su historial.',
        canDo: [
          'Abrir controles en curso o revisar controles cerrados.',
          'Seguir diferencias detectadas en una hoja puntual.',
        ],
        nextStepHint: 'Si ya existe un control y querés seguirlo, la lectura correcta está en Hojas de control.',
      },
      'Informe ejecutivo': {
        summary: 'Informe ejecutivo condensa stock, compras, salidas y diferencias en una lectura rápida.',
        purpose: 'Entender el estado general del depósito sin entrar a cada registro.',
        canDo: [
          'Leer un resumen del módulo.',
          'Detectar qué área del depósito necesita atención primero.',
        ],
        nextStepHint: 'Si querés una mirada general antes de operar, arrancá por Informe ejecutivo.',
      },
      'Estadísticas': {
        summary: 'Estadísticas convierte la actividad del depósito en números comparables y lectura histórica.',
        purpose: 'Ver tendencias sin bajar al detalle de cada movimiento.',
        canDo: [
          'Comparar actividad, volúmenes y frecuencia de movimientos.',
          'Detectar cambios de ritmo en el depósito.',
        ],
        nextStepHint: 'Si ya no buscás un caso puntual sino una tendencia, pasá a Estadísticas.',
      },
      'GIA Stock': {
        summary: 'GIA Stock te ayuda a ubicar la sección correcta y el siguiente paso dentro del depósito.',
        purpose: 'Bajar dudas rápidas sin cortar el trabajo.',
        canDo: [
          'Explicar compras, salidas, movimientos y controles.',
          'Orientarte a la parte correcta del módulo según lo que necesitás hacer.',
        ],
        nextStepHint: 'Si no sabés dónde seguir dentro de Stock, GIA Stock te reubica rápido.',
      },
    },
  };

export default GIA_MODULE_KNOWLEDGE;
